import React, {Component} from "react"

import id from "@irati/utils/id"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import {Hidden} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import Benefit from "@irati/deals/types/Benefit"

import UploadImage from "./UploadImage/UploadImage"
import UploadedImage from "./UploadImage/UploadedImage"
import SectionHeading from "./styled/SectionHeading"
import ErrorWrapper from "./styled/ErrorWrapper"

interface Props extends InjectIntl {
  id: string,
  benefit: Benefit,
  onChange: () => void,
  heading: string,
  name: string,
  property: string,
  width: number,
  height: number,
  validation?: (formatMessage?: FormatMessage) => boolean
}

class CardImageUpload extends Component<Props> {
  schema(formatMessage: FormatMessage): boolean {
    return Validation.string(
      formatMessage({id: "admin.components.cardImage.cardImageSchema.validation.string"})
    )
  }

  get value(): string {
    const {benefit, property} = this.props
    return benefit[property]
  }

  render() {
    const {benefit, onChange, heading, name, property, width, height, formatMessage, validation} = this.props
    const schema = validation || this.schema

    return <>
      <SectionHeading>
        <FormattedMessage id={heading} />
      </SectionHeading>
      <ErrorWrapper>
        <Hidden
          name={name}
          value={this.value}
          validation={schema(formatMessage)} />
      </ErrorWrapper>
      <UploadedImage
        benefit={benefit}
        onDelete={onChange}
        property={property} />
      <UploadImage
        id={id(property, this.props)}
        property={property}
        onChange={onChange}
        dimensions={{width, height}} />
    </>
  }
}

export default injectIntl(CardImageUpload)
